import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import VueLazyload from "vue-lazyload";
import "babel-polyfill";
import "animate.css";
// 重置样式
import "@/assets/style/reset.css";
// iview主题样式
import "@/assets/style/iview/theme.less";
// 自定义全局样式
import "@/assets/style/global/index.less";
// 字体图标
import "@/assets/font_grx8fppmwri/iconfont.css";

import HTTP_API from "@/apis/httpApi";

import iView from "view-design";
import fn from "@/utils/fn.ts";
import Component from "vue-class-component";
import QRCode from "qrcodejs2"; // 二维码
import VueClipboard from "vue-clipboard2"; // 复制粘贴插件

// 全局登录组件
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);

// 复制组件
Vue.use(VueClipboard);
// iview全局使用
Vue.use(iView, {
  transfer: true,
});

Vue.use(VueLazyload, {
  // 这里表示在加载时要显示的图片的路径
  loading: require("./assets/img/default/default.png"),
});

// prop全局
Vue.prototype.$fn = fn;
Vue.prototype.$HTTP_API = HTTP_API;

Vue.config.productionTip = false;
Vue.prototype.QRCode = QRCode;

(function initOriginUrl() {
  const originUrl = location.host;
  if (originUrl.includes("996yinqing")) {
    Vue.prototype.$companyName = '杭州慧跃网络科技有限公司'
    document.title = '杭州慧跃网络科技有限公司'
  } else {
    Vue.prototype.$companyName = '杭州慧起网络科技有限公司'
    document.title = '杭州慧起网络科技有限公司'
  }
  // if (originUrl.includes("996yinqing")) {
  //   Vue.prototype.$companyName = '996传奇引擎'
  //   document.title = '996传奇引擎'
  // } else {
  //   Vue.prototype.$companyName = '996传奇引擎'
  //   document.title = '996传奇引擎'
  // }
})()

window.App = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
